<div class="card" [ngClass]="{ selected: selected }" (click)="selectCard()">
    <div class="card-body d-flex">
        <div class="card-content">
            <span class="card-content-title">{{ serviceInfo.name | translate }}</span>
            <span>
                <i class="card-content-icon" [ngClass]="iconClass"></i> 
            </span>
        </div>
    </div>
</div>